module.exports = __webpack_public_path__ + "static/media/toyota.5add6938.png";